<div class="products-page">
  <div class="container">
    <!-- Breadcrumb -->
    <nav class="breadcrumb" aria-label="Breadcrumb">
      <a href="/">Início</a>
      <span class="breadcrumb-separator">›</span>
      <span class="breadcrumb-current">
        @if (hasSearch) {
          Resultados para "{{ searchQuery() }}"
        } @else {
          Produtos
        }
      </span>
    </nav>

    <!-- Main Content -->
    <div class="products-layout">
      <!-- Sidebar de Filtros -->
      <aside class="products-sidebar d-mobile-none">
        <app-filters-sidebar (filtersChange)="onFiltersChange($event)"></app-filters-sidebar>
      </aside>

      <!-- Lista de Produtos -->
      <main class="products-main">
        <!-- Barra de Ordenação -->
        <div class="products-toolbar">
          <div class="toolbar-info">
            @if (!isLoading()) {
              <span class="result-count">
                {{ resultCount }} {{ resultCount === 1 ? 'resultado' : 'resultados' }}
              </span>
            }
          </div>

          <div class="toolbar-sort">
            <label for="sort-select" class="sort-label">Ordenar por:</label>
            <select 
              id="sort-select"
              class="sort-select"
              [value]="sortBy()"
              (change)="onSortChange($event)"
            >
              <option value="relevancia">Mais relevantes</option>
              <option value="menor-preco">Menor preço</option>
              <option value="maior-preco">Maior preço</option>
              <option value="nome-az">Nome A-Z</option>
              <option value="nome-za">Nome Z-A</option>
            </select>
          </div>
        </div>

        <!-- Product List Component -->
        <app-product-list
          [products]="displayedProducts()"
          [isLoading]="isLoading()"
          [currentPage]="currentPage()"
          [itemsPerPage]="20"
          (pageChange)="onPageChange($event)"
        ></app-product-list>
      </main>
    </div>
  </div>
</div>

